/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Downloadlinkscolumnlast7days4Inputs */

const en_downloadlinkscolumnlast7days4 = /** @type {(inputs: Downloadlinkscolumnlast7days4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last 7 days`)
};

const de_downloadlinkscolumnlast7days4 = /** @type {(inputs: Downloadlinkscolumnlast7days4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Letzte 7 Tage`)
};

/**
* | output |
* | --- |
* | "Last 7 days" |
*
* @param {Downloadlinkscolumnlast7days4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const downloadlinkscolumnlast7days4 = /** @type {((inputs?: Downloadlinkscolumnlast7days4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Downloadlinkscolumnlast7days4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_downloadlinkscolumnlast7days4(inputs)
	return de_downloadlinkscolumnlast7days4(inputs)
});
export { downloadlinkscolumnlast7days4 as "downloadLinksColumnLast7Days" }